import React, {useState, useRef, useEffect} from 'react'
// import { Link } from 'react-router-dom'
import axios from "axios"
import {  useSelector, useDispatch } from "react-redux";
import { set_page_refresh } from '../../redux/action';

const AddVariant = () => {
    const dispatch = useDispatch();
    const [variant, setVariant] = useState({})
    const data = useSelector((state) => state.variant_edit);
    const closeRef = useRef(null);
    
    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || "en");
    useEffect(() => {
        console.log("brandData", data)
        if(!data?.name) {
            setVariant({name: "", attributes: "", customized: false})
        } else {
            setVariant(data)
        }
        
    }, [data])
    const submit= async (event) => {
        event.preventDefault()
        event.stopPropagation()
        const form = event.currentTarget;
        console.log()
        try {
        if(form?.checkValidity()) {

            let res = await axios.post('addvariant/', variant)
            console.log(res)
            if(res.status == 200) {
                closeRef.current?.click()
                document.querySelector(".modal-backdrop").classList.toggle("show")
                dispatch(set_page_refresh("variants"))
            }
        }
        } catch(e) {
        console.log(e)
        return true;
        }
        

        return true;
    }
    const handleInputChange = (e) => {
        console.log(e)
        // const { name, value } = e.target;
        // setVariant(prevState => ({
        // ...prevState,
        // [name]: value
        // }));
        const { name, value, type, checked } = e.target;
        setVariant(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));
    };
    return (
        <>
            {/* Add Unit */}
            <div className="modal fade" id="add-units">
                <div className="modal-dialog modal-dialog-centered custom-modal-two">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>{Object.keys(data || {}).length ? t?.[l]?.["edit_variant"] || "Edit Variant" : t?.[l]?.["create_variant"] || "Create Variant"}</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    <form onSubmit={submit}>
                                        
                                        <div className="mb-3">
                                            <label className="form-label">{t?.[l]?.["name"] || "Name"}</label>
                                            <input type="text" className="form-control" value={variant?.name || ""} required name="name" onChange={handleInputChange} />
                                        </div>
                                        <div className="input-blocks">
                                            <label className="form-label">{t?.[l]?.["variant"] || "Variant"}</label>
                                            <input placeholder={t?.[l]?.["enter_value_separated_by_comma"] || "Enter value separated by comma"} value={variant?.attributes || ""} type="text" className="form-control" required name="attributes" onChange={handleInputChange} />
                                        </div>

                                        <div className="mb-0">
                                            <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                                                <span className="status-label">{t?.[l]?.["customized"] || "Customized (to get users data)"}</span>
                                                <input
                                                    type="checkbox"
                                                    id="customized"
                                                    name="customized"
                                                    className="check"
                                                    checked={variant?.customized || false} 
                                                    onChange={handleInputChange}
                                                />
                                                <label htmlFor="customized" className="checktoggle" />
                                            </div>
                                        </div>

                                        <div className="modal-footer-btn">
                                            <button
                                                type="button"
                                                className="btn btn-cancel me-2"
                                                data-bs-dismiss="modal"
                                                ref={closeRef}
                                            >
                                                {t?.[l]?.["cancel"] || "Cancel"}
                                            </button>
                                            <button  type="submit" className="btn btn-submit">
                                                {t?.[l]?.["save"] || "Save"}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Unit */}
        </>

    )
}

export default AddVariant
